import React, { useEffect } from "react";
import { Select, Form } from "antd";
import { connect } from 'react-redux';
import { GET_CLIENTS } from '../../../store/actions/client';
import formItemLayout from "../../../const/form/formItemLayout";
const { Option } = Select;

function Company({clients, GET_CLIENTS, data, setData, style = { width: "100%" }, optionAll = false }){
    useEffect(() => {
        let body = {
            jwt: localStorage.getItem('@Ossel:token')
        };

        GET_CLIENTS(body)
    }, []);
  
    return(
        <Form.Item 
            {...formItemLayout} 
            label={"Cliente"} 
            hasFeedback
            required={true}
        >
            <Select
                showSearch
                style={style}
                placeholder="Selecione um Cliente"
                optionFilterProp="children"
                onChange={e => setData(data = {...data, client: e})}
                value={data.client}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                loading={clients.loading}
            >
                {
                    clients.data.data && clients.data.data.clients.map(client => {
                        return <Option key={client._id} value={client._id}>{client.name}</Option>
                    })
                }
            </Select>
        </Form.Item>
    )
}

const mapStateToProps = state => {
    return {
        clients: state.clientR
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GET_CLIENTS: body => dispatch(GET_CLIENTS(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Company);


// WEBPACK FOOTER //
// ./src/components/common/selects/Clients.jsx